import { render } from "./SelectActions.vue?vue&type=template&id=46c71a29"
import script from "./SelectActions.vue?vue&type=script&lang=js"
export * from "./SelectActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__